import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    lineHeight: 1.5,
    textAlign: 'center',
  },
});
